import {
  hasSelectedPenibilite,
  normalizePenibilite,
} from 'components/SlideOver/dataSlideOver/data/slideOverAddMission/missionTemplate/templateFormData';
import { missionDetailText } from './missionDetailTexts';

/** The « Poste à risque » form, filled from the mission's conditions. */
export const missionRiskFormOf = (mission) => ({
  position_at_risk: !!mission?.conditions?.position_at_risk,
  penibilite: normalizePenibilite(mission?.conditions?.penibilite),
});

// The switch keeps the factors while it is off so they survive a change of
// mind; a position that is not at risk carries none.
const normalizedRisk = (risk) => ({
  position_at_risk: !!risk?.position_at_risk,
  penibilite: risk?.position_at_risk
    ? normalizePenibilite(risk.penibilite)
    : {},
});

const sameFactors = (a, b) => {
  const keysA = Object.keys(a).sort();
  const keysB = Object.keys(b).sort();
  return (
    keysA.length === keysB.length &&
    keysA.every((key, index) => key === keysB[index])
  );
};

/** The `riskyPosition` change of the edit form, or null. */
export const riskyPositionChange = (mission, riskForm) => {
  if (!riskForm) return null;
  const before = normalizedRisk(mission?.conditions);
  const after = normalizedRisk(riskForm);
  if (
    before.position_at_risk === after.position_at_risk &&
    sameFactors(before.penibilite, after.penibilite)
  ) {
    return null;
  }
  return { field: 'riskyPosition', before: missionRiskFormOf(mission), after };
};

/** Why the risky position cannot be saved, or null. Checked as the api checks it. */
export const riskyPositionError = (mission, riskForm) => {
  const change = riskyPositionChange(mission, riskForm);
  return change?.after.position_at_risk &&
    !hasSelectedPenibilite(change.after.penibilite)
    ? missionDetailText('risk.factorRequired')
    : null;
};
